// extracted by mini-css-extract-plugin
module.exports = {"root":"BlockMealsCms_root__cmMbc","title":"BlockMealsCms_title__SzwUM","text":"BlockMealsCms_text__tEsMX"};